// NPM Imports
import React, { Fragment, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { ResizableBox } from "react-resizable";

// Internal Imports
import { DOCUMENTS } from "../../../constants";
import QuotationActions from "../../../actions/QuotationActions";
import ToolbarActions from "../../../actions/ToolbarActions";
import {
  updateHoveredDocumentSectionId,
  updateDocumentClickedComponentID,
  updateAddEsignBlockData,
  addEsignBlockData,
  updateDraggedSection,
} from "../../../actions/DocumentActions";

import { DocumentUtils } from "../../../utils";
import {
  MAX_ESIGN_HEIGHT,
  MAX_ESIGN_WIDTH,
  INITIAL_ESIGN_WIDTH,
  INITIAL_ESIGN_HEIGHT,
  MIN_ESIGN_HEIGHT,
  MIN_ESIGN_WIDTH,
} from "../../../constants/images";
// Destructuring
const { DOCUMENT_SIGNATURE_CONTEXT, DOCUMENT_MODE } = DOCUMENTS;
const { setSectionDataForActiveSignatureInRightToolPane } = QuotationActions;
const {
  updateAddComponentinToolbarAction,
  updateToolpaneView,
} = ToolbarActions;
const { convertSignersData } = DocumentUtils;

class SignatureContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      esginWidth: INITIAL_ESIGN_WIDTH,
      esginHeight: INITIAL_ESIGN_HEIGHT,
      mouseDown: false,
    };
  }

  async componentDidMount() {
    this.props.updateDraggedSection(null, null);
    document.addEventListener("mouseup", this._handleResizeOutside);
    if (
      this.props.signersData &&
      this.props.isPdfDocument &&
      Array.isArray(this.props.signersData) &&
      Object.keys(this.props.signersData[0].signer_config).length > 0 &&
      Array.isArray(this.props.signersData[0].signer_config.options)
    ) {
      this.setState({
        esginWidth: this.props.signersData[0].signer_config.options[0].width,
        esginHeight: this.props.signersData[0].signer_config.options[0].height,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mouseup", this._handleResizeOutside);
  }

  _handleResizeOutside = () => {
    if (this.state.mouseDown) {
      this._onMouseUp();
    }
  };

  _onMouseUp = () => {
    const { isComponentActive, isLocked } = this.props;
    if (!isLocked && isComponentActive) {
      this.setState(
        {
          mouseDown: false,
        },
        () => {
          const signData = JSON.parse(JSON.stringify(this.props.sigData));
          const signersData = signData.filter(
            data => data.component_id === this.props.clickedActiveComponentId,
          );

          signersData[0].signers[0].signer_config.options[0].width = this.state.esginWidth;
          signersData[0].signers[0].signer_config.options[0].height = this.state.esginHeight;
          signersData[0].signers[0].signer_config.options[1].width = this.state.esginWidth;
          signersData[0].signers[0].signer_config.options[1].height = this.state.esginHeight;
          signersData[0].signers[0].signer_config.options[2].width = this.state.esginWidth;
          signersData[0].signers[0].signer_config.options[2].height = this.state.esginHeight;
          const payload = [
            {
              component_id: this.props.clickedActiveComponentId,
              signers: signersData[0].signers,
            },
          ];
          this.props.updateAddEsignBlockData(payload);
          this.props.addEsignBlockData(this.props.documentID, payload);
        },
      );
      return true;
    }
    return false;
  };

  _onResize = (event, { size }) => {
    const { isLocked, clickedActiveComponentId } = this.props;
    if (!isLocked && clickedActiveComponentId) {
      if (size.width >= MIN_ESIGN_WIDTH && size.height >= MIN_ESIGN_HEIGHT) {
        this.setState({
          esginWidth: size.width,
          esginHeight: size.height,
          mouseDown: true,
        });
      }
    }
  };

  _onMoveToSignatureToolPane = event => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if (this.props.showFormMode) {
      const { docStage, section, isComponentActive, mode } = this.props;
      if (
        docStage === "DRAFT" &&
        section &&
        !isComponentActive &&
        !this.props.isLocked
      ) {
        this.props.updateDocumentClickedComponentID(
          section.id,
          false,
          section.type,
        );
        const updatedSection = {
          ...this.props.section,
          data: this.props.signersData,
        };
        this.props.setSectionDataForActiveSignatureInRightToolPane(
          updatedSection,
        );
        this.props.updateToolpaneView(section, mode);
      }
    } else {
      const {
        isLocked,
        section,
        isComponentActive,
        mode,
        docStage,
        isPdfDocument,
      } = this.props;
      if (!isLocked && !isComponentActive && section && !isPdfDocument) {
        this.props.createDocSectionRef(React.createRef());
        this.props.updateDocumentClickedComponentID(
          section.id,
          false,
          section.type,
        );
        const updatedSection = {
          ...this.props.section,
          data: this.props.signersData,
        };
        this.props.setSectionDataForActiveSignatureInRightToolPane(
          updatedSection,
        );
        this.props.updateHoveredDocumentSectionId(section.id, null);
        this.props.updateToolpaneView(section, mode);
      } else if (
        !isLocked &&
        this.props.isPdfDocument &&
        docStage === "DRAFT"
      ) {
        const newData = {
          id: this.props.pdfSectionId,
          type: "Signature",
          data: this.props.signersData,
        };
        this.props.updateDocumentClickedComponentID(
          this.props.pdfSectionId,
          false,
          "Signature",
        );
        this.props.setSectionDataForActiveSignatureInRightToolPane(newData);
        this.props.updateToolpaneView(newData, mode);
      } else if (!this.props.isPdfDocument) {
        this.props.updateToolpaneView(section, mode);
      }
    }
  };

  _handleOnClick = event => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if (this.props.showFormMode) {
      const {
        docStage,
        section,
        isComponentActive,
        mode,
        isLocked,
      } = this.props;
      if (docStage === "DRAFT" && section && !isComponentActive && !isLocked) {
        this.props.updateDocumentClickedComponentID(
          section.id,
          false,
          section.type,
        );
        const updatedSection = {
          ...this.props.section,
          data: this.props.signersData,
        };
        this.props.setSectionDataForActiveSignatureInRightToolPane(
          updatedSection,
        );
        this.props.updateToolpaneView(section, mode);
      }
    } else {
      const {
        isLocked,
        section,
        isComponentActive,
        mode,
        isPdfDocument,
        docStage,
      } = this.props;
      if (!isLocked && !isComponentActive && section && !isPdfDocument) {
        this.props.createDocSectionRef(React.createRef());
        this.props.updateDocumentClickedComponentID(
          section.id,
          false,
          section.type,
        );
        const updatedSection = {
          ...this.props.section,
          data: this.props.signersData,
        };
        this.props.setSectionDataForActiveSignatureInRightToolPane(
          updatedSection,
        );
        this.props.updateHoveredDocumentSectionId(section.id, null);
        this.props.updateToolpaneView(section, mode);
      } else if (
        !isLocked &&
        this.props.isPdfDocument &&
        docStage === "DRAFT"
      ) {
        const newData = {
          id: this.props.pdfSectionId,
          type: "Signature",
          data: this.props.signersData,
        };
        this.props.updateDocumentClickedComponentID(
          this.props.pdfSectionId,
          false,
          "Signature",
        );
        this.props.setSectionDataForActiveSignatureInRightToolPane(newData);
        this.props.updateToolpaneView(newData, mode);
      }
      // else if (!this.props.isPdfDocument && ) {
      //   this.props.updateToolpaneView(section, mode);
      // }
    }
  };

  _handleOnBlur = event => {
    event.preventDefault();
    if (
      this.props.isComponentActive &&
      this.props.preventClickedComponentIdUpdateInfo
    ) {
      this.props.updateDocumentClickedComponentID(null, true, null);
      this.props.setSectionDataForActiveSignatureInRightToolPane({});
    }
  };

  _getCenterLabel = () => {
    let AddSignerTitle = "Assign signer";
    if (this.props.totalRowItems > 3) {
      AddSignerTitle = "Add signer details to signer tags";
    }
    let component = null;
    if (
      this.props.showFormMode &&
      this.props.docStage === "DRAFT" &&
      !this.props.isComponentActive &&
      !this.props.isLocked
    ) {
      component = (
        <div className="tooltip-for-signature-update">
          <span
            className="assign-signer-select"
            id="edit-sec-btn"
            onClick={this._onMoveToSignatureToolPane}
            onKeyPress={() => {}}
            role="button"
            tabIndex={0}>
            {DOCUMENT_MODE.DOCUMENT === this.props.mode ? (
              <Fragment>
                <i className="edit-icon">
                  <FontAwesomeIcon icon={["far", "edit"]} />
                </i>
                {AddSignerTitle}
              </Fragment>
            ) : (
              <Fragment>
                <i className="edit-icon">
                  <FontAwesomeIcon icon={["far", "cog"]} />
                </i>
                Open signature placeholder settings
              </Fragment>
            )}
          </span>
        </div>
      );
    } else if (
      !this.props.showFormMode &&
      !this.props.isComponentActive &&
      !this.props.isLocked &&
      !this.props.isPdfDocument
    ) {
      component = (
        <div className="tooltip-for-signature-update">
          <span
            id="edit-sec-btn"
            onClick={this._onMoveToSignatureToolPane}
            onKeyPress={() => {}}
            role="button"
            tabIndex={0}>
            {DOCUMENT_MODE.DOCUMENT === this.props.mode ? (
              <Fragment>
                <i className="edit-icon">
                  <FontAwesomeIcon icon={["far", "edit"]} />
                </i>
                {AddSignerTitle}
              </Fragment>
            ) : (
              <Fragment>
                <i className="edit-icon">
                  <FontAwesomeIcon icon={["far", "cog"]} />
                </i>
                Open signature placeholder settings
              </Fragment>
            )}
          </span>
        </div>
      );
    } else if (
      !this.props.showFormMode &&
      !this.props.isLocked &&
      this.props.docStage === "DRAFT" &&
      this.state.esginWidth >= 160
    ) {
      component = (
        <div className="tooltip-for-signature-update">
          <span
            id="edit-sec-btn"
            className="assign-signer-select"
            onClick={this._onMoveToSignatureToolPane}
            onKeyPress={() => {}}
            role="button"
            tabIndex={0}>
            {DOCUMENT_MODE.DOCUMENT === this.props.mode ? (
              <Fragment>
                <i className="edit-icon">
                  <FontAwesomeIcon icon={["far", "edit"]} />
                </i>
                {AddSignerTitle}
              </Fragment>
            ) : (
              <Fragment>
                <i className="edit-icon">
                  <FontAwesomeIcon icon={["far", "cog"]} />
                </i>
                Open signature placeholder settings
              </Fragment>
            )}
          </span>
        </div>
      );
    }
    return component;
  };

  _getDataLabel = newData => {
    let dataLabel;
    if (newData === "INITIALS") {
      dataLabel = "Initials";
    } else if (newData === "CAPTURE") {
      dataLabel = "Capture";
    } else {
      dataLabel = "Signature";
    }
    return dataLabel;
  };

  render() {
    const { sectionID, isComponentActive, signersData } = this.props;
    const { esginHeight, esginWidth } = this.state;
    const unit = "px";
    const containerWidth =
      MAX_ESIGN_WIDTH -
      (signersData && this.props.isPdfDocument
        ? signersData[0].signer_config.point.x
        : 5);
    let getValidWidth = containerWidth;
    if (esginWidth <= containerWidth) {
      getValidWidth = esginWidth;
    }
    let getValidHeight = esginHeight;
    if (esginHeight > MAX_ESIGN_HEIGHT) {
      getValidHeight = MAX_ESIGN_HEIGHT;
    }
    const esignStyles = {
      width: `${esginWidth}${unit}`,
      height: `${getValidHeight}${unit}`,
    };
    return (
      <Fragment>
        {DOCUMENT_MODE.TEMPLATE === this.props.mode && (
          <div className="clause-product-name">
            <span className="label-text">
              {" "}
              <i className="edit-icon">
                <FontAwesomeIcon icon={["far", "info-circle"]} />
              </i>{" "}
              Signature placeholder
            </span>
          </div>
        )}

        <div
          id={sectionID}
          className={`signature-component ${
            isComponentActive ? "active-signature" : ""
          }`}
          onClick={this._handleOnClick}
          onKeyPress={() => {}}
          onBlur={this._handleOnBlur}
          role="button"
          tabIndex={0}>
          {this.props.isPdfDocument ? (
            <ResizableBox
              className="box"
              onMouseUp={this._onMouseUp}
              height={Number(getValidHeight)}
              width={Number(getValidWidth)}
              onResize={this._onResize}
              minConstraints={[60, 20]}
              // lockAspectRatio
              resizeHandles={
                this.props.isLocked
                  ? []
                  : ["sw", "se", "nw", "ne", "w", "e", "n", "s"]
              }>
              <div>
                <div
                  draggable={`${
                    this.props.isPdfDocument &&
                    this.props.docStage === "DRAFT" &&
                    this.props.isComponentActive
                      ? "true"
                      : "false"
                  }`}>
                  {this._getCenterLabel()}
                  {/* {!isComponentActive && !isLocked && (
            <div className="tooltip-for-signature-update">
              <span
                id="edit-sec-btn"
                onClick={this._onMoveToSignatureToolPane}
                onKeyPress={() => {}}
                role="button"
                tabIndex={0}>
                {DOCUMENT_MODE.DOCUMENT === this.props.mode ? (
                  <Fragment>
                    <i className="edit-icon">
                      <FontAwesomeIcon icon={["far", "edit"]} />
                    </i>
                    Click to assign Recipients
                  </Fragment>
                ) : (
                  <Fragment>
                    <i className="edit-icon">
                      <FontAwesomeIcon icon={["far", "cog"]} />
                    </i>
                    Open signature settings
                  </Fragment>
                )}
              </span>
            </div>
          )} */}

                  <div className="signature-section">
                    {signersData.length > 0 ? (
                      signersData.map((item, index) => (
                        <div
                          data-email={item.signer_email}
                          className="add-signature-component">
                          {item.signer_config.options.map(signer => (
                            <Fragment>
                              {signer.checked && (
                                <div
                                  style={esignStyles}
                                  className={`sign-box resize-esign-box signer-${index +
                                    1} ${item.firstName ? "added" : ""} ${
                                    this.props.totalRowItems > 3
                                      ? "small-box"
                                      : ""
                                  }`}>
                                  {item.first_name && (
                                    <FontAwesomeIcon
                                      icon={["fas", "check-circle"]}
                                      className="link-icon-check"
                                    />
                                  )}
                                  <FontAwesomeIcon
                                    icon={
                                      DOCUMENT_SIGNATURE_CONTEXT[signer.id].icon
                                    }
                                    className={`link-icon ${
                                      item.firstName ? "hide" : ""
                                    }`}
                                  />
                                  <div
                                    className={`sign-box-label ${
                                      this.state.esginWidth <= 145
                                        ? "font-assign"
                                        : ""
                                    }`}>
                                    <div
                                      data-label={
                                        signer.id === "signature"
                                          ? this._getDataLabel(
                                              item.signer_config.signature_type,
                                            )
                                          : DOCUMENT_SIGNATURE_CONTEXT[
                                              signer.id
                                            ].label
                                      }
                                      className="sign-box-label-font">
                                      {
                                        DOCUMENT_SIGNATURE_CONTEXT[signer.id]
                                          .label
                                      }
                                    </div>
                                    <div
                                      className={`signbox-sub-label ${
                                        this.state.esginWidth <= 145
                                          ? "font-assign"
                                          : ""
                                      }`}>
                                      {item.first_name || item.last_name
                                        ? `${item.first_name} ${item.last_name}`
                                        : `Assign signer ${index + 1}`}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Fragment>
                          ))}
                        </div>
                      ))
                    ) : (
                      <div className="add-signature-component">
                        <div
                          className="sign-box resize-esign-box"
                          style={esignStyles}>
                          <FontAwesomeIcon
                            icon={DOCUMENT_SIGNATURE_CONTEXT.signature.icon}
                            className="link-icon"
                          />
                          <div
                            className={`sign-box-label ${
                              this.state.esginWidth < 145 ? "font-assign" : ""
                            }`}>
                            <div
                              data-label={
                                DOCUMENT_SIGNATURE_CONTEXT.signature.label
                              }
                              className="sign-box-label-font">
                              {DOCUMENT_SIGNATURE_CONTEXT.signature.label} (1)
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ResizableBox>
          ) : (
            <div>
              <div
                draggable={`${
                  this.props.isPdfDocument &&
                  this.props.docStage === "DRAFT" &&
                  this.props.isComponentActive
                    ? "true"
                    : "false"
                }`}>
                {this._getCenterLabel()}
                <div className="signature-section">
                  {signersData.length > 0 ? (
                    signersData.map((item, index) => (
                      <div
                        data-email={item.signer_email}
                        className="add-signature-component">
                        {item.signer_config.options.map(signer => (
                          <Fragment>
                            {signer.checked && (
                              <div
                                className={`sign-box signer-${index + 1} ${
                                  item.firstName ? "added" : ""
                                } ${
                                  this.props.totalRowItems > 3
                                    ? "small-box"
                                    : ""
                                }`}>
                                {item.first_name && (
                                  <FontAwesomeIcon
                                    icon={["fas", "check-circle"]}
                                    className="link-icon-check"
                                  />
                                )}
                                <FontAwesomeIcon
                                  icon={
                                    DOCUMENT_SIGNATURE_CONTEXT[signer.id].icon
                                  }
                                  className={`link-icon ${
                                    item.firstName ? "hide" : ""
                                  }`}
                                />
                                <div className="sign-box-label">
                                  <div
                                    data-label={
                                      signer.id === "signature"
                                        ? this._getDataLabel(
                                            item.signer_config.signature_type,
                                          )
                                        : DOCUMENT_SIGNATURE_CONTEXT[signer.id]
                                            .label
                                    }
                                    className="sign-box-label-font">
                                    {
                                      DOCUMENT_SIGNATURE_CONTEXT[signer.id]
                                        .label
                                    }
                                  </div>
                                  <div className="signbox-sub-label">
                                    {item.first_name || item.last_name
                                      ? `${item.first_name} ${item.last_name}`
                                      : `Assign signer ${index + 1}`}
                                  </div>
                                </div>
                              </div>
                            )}
                          </Fragment>
                        ))}
                      </div>
                    ))
                  ) : (
                    <div className="add-signature-component">
                      <div className="sign-box">
                        <FontAwesomeIcon
                          icon={DOCUMENT_SIGNATURE_CONTEXT.signature.icon}
                          className="link-icon"
                        />
                        <div className="sign-box-label">
                          <div
                            data-label={
                              DOCUMENT_SIGNATURE_CONTEXT.signature.label
                            }
                            className="sign-box-label-font">
                            {DOCUMENT_SIGNATURE_CONTEXT.signature.label} (1)
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { sectionID, mode } = props;
  // const sectionList = [];
  let signersData = [];
  let section;
  let isComponentActive = false;
  let preventClickedComponentIdUpdateInfo;
  let docStage;
  let showFormMode;
  let isPdfDocument = false;
  let pdfSectionId = null;
  let sigData;
  let documentID;
  const {
    components,
    preventClickedComponentIdUpdate,
    clickedActiveComponentId,
  } = state.DocumentStore;

  if (DOCUMENT_MODE.TEMPLATE === mode) {
    preventClickedComponentIdUpdateInfo = preventClickedComponentIdUpdate;
    section = components[sectionID].content;
    signersData = convertSignersData(components[sectionID].content.data);
    if (clickedActiveComponentId === sectionID) isComponentActive = true;
  }

  if (DOCUMENT_MODE.DOCUMENT === mode) {
    const {
      document: { id, stage, showForm, signatories, isPdfDocument: isPdfDoc },
    } = state.DocumentStore;
    sigData = signatories;
    signersData = signatories.filter(d => d.component_id === sectionID);
    signersData =
      signersData.length > 0 && signersData[0].signers
        ? signersData[0].signers
        : [];
    docStage = stage;
    documentID = id;
    showFormMode = showForm;
    isPdfDocument = isPdfDoc;
    pdfSectionId = sectionID;
    preventClickedComponentIdUpdateInfo = preventClickedComponentIdUpdate;
    section = components[sectionID] && components[sectionID].content;
    if (clickedActiveComponentId === sectionID) isComponentActive = true;
  }

  return {
    // row,
    // col,
    section,
    signersData,
    isComponentActive,
    preventClickedComponentIdUpdateInfo,
    docStage,
    showFormMode,
    isPdfDocument,
    pdfSectionId,
    sigData,
    documentID,
  };
};

const mapDispatchToProps = {
  setSectionDataForActiveSignatureInRightToolPane,
  updateAddComponentinToolbarAction,
  updateHoveredDocumentSectionId,
  updateDocumentClickedComponentID,
  updateToolpaneView,
  updateAddEsignBlockData,
  addEsignBlockData,
  updateDraggedSection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignatureContainer);



// WEBPACK FOOTER //
// ./src/components/DocumentItems/SignatureContainer/SignatureContainer.js